<template>
  <div class="menu">
    <div class="order-placed">
      <p class="heading">Payment</p>
      <p>
        Your Order Id is <span class="id">#{{ this.orderId }}</span>
      </p>

      <p>
        <span
          >For enquires:
          <span class="number">Call us at +977-015970770 (Kathmandu)</span>
          <span class="number"
            >Call us at +977-015970880/9802838383 (Pokhara)</span
          >
        </span>
      </p>
    </div>

    <modal
      v-show="isModalVisible"
      @close="closeModal"
      @phone="userPhone"
      @email="userEmail"
    />
  </div>
</template>

<script>
// @ is an alias to /src\

import { mapGetters, mapActions } from "vuex";
import BannerOne from "../../components/BannerOne.vue";
import { CartData } from "../../services/storage.service";
import router from "../../router";
import axios from "axios";
import { format } from "date-fns";
import Modal from "../../components/Modal";

export default {
  name: "PaymentMethod",
  components: {
    BannerOne,
    Modal,
  },
  data() {
    return {
      isModalVisible: false,
      email: "",
      number: "",
      paymentprocess: false,
      orderId: CartData.getOrderId(),
      totalAmount: CartData.getCartAmount(),
    };
  },
  created() {
    window.scrollTo(0, 0);

    // if (
    //   this.payMode === 1 ||
    //   this.payMode === 2 ||
    //   this.payMode === 4 ||
    //   this.payMode === 6
    // ) {
    //   if (this.oId > 0) {
    //     let routeData = this.$router.resolve({ name: "OrderStatus" });
    //     window.open(routeData.href, "OrderStatus");
    //   }
    // } else {
    //   this.clearCart();
    //   router.replace("/p/orderstatus");
    // }

    if (this.payMode === 1) {
      this.handleEsewaPayment();
    } else if (this.payMode === 2) {
      this.showModal();
    } else if (this.payMode === 6) {
      this.handleIMETokenGeneration();
    } else if (this.payMode === 4) {
      // this.createFonePaySignature();
      router.replace("/p/fonepaypayment");
    }
  },
  computed: {
    ...mapGetters([
      "cartItems",
      "cartTotal",
      "payMode",
      "getPromoDiscountTotal",
      "getVAT",
      "getIntlTransferCharge",
    ]),
  },
  methods: {
    ...mapActions(["clearCart", "updateStep"]),
    userPhone: function (value) {
      this.paymentprocess = true;
      this.number = value;
    },
    userEmail: function (value) {
      this.email = value;
      if (this.number !== "" && this.email !== "") {
        this.handleNICASignature();
      }
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },

    handleIMETokenGeneration() {
      // let path = `https://manager.khaanpin.com/apiv2/imepaytoken/`;
      let path = `https://deus.khaanpin.com/appapi/imepaytoken/`;


      const data = {
        cart_id: CartData.getOrderId(),
      };

      axios.post(path, data).then(
        (response) => {
          if (response.data.error === false) {
            this.handleIMEPayment(response.data.data);
          }
        },
        (error) => {
          console.log("ERROR", error);
        }
      );
    },

    handleIMEPayment(data) {
      let testpath = `https://stg.imepay.com.np:7979/WebCheckout/Checkout`;
      let livepath = `https://payment.imepay.com.np:7979/WebCheckout/Checkout`;

      let params = {
        TokenId: data.token,
        MerchantCode: "KHAANPIN",
        RefId: data.ref_id,
        TranAmount: data.amount,
        Method: "POST",
        // RespUrl: "https://manager.khaanpin.com/apiv2/imepaymentdetails/",
        RespUrl: "https://deus.khaanpin.com/appapi/imepaymentdetails/",

        // CancelUrl: "https://manager.khaanpin.com/apiv2/imepaymentdetails/",
        CancelUrl: "https://deus.khaanpin.com/appapi/imepaymentdetails/",

      };

      let form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", livepath);

      for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);
      form.submit();
    },

    handleEsewaPayment() {
      var path = "https://esewa.com.np/epay/main";
      // var path = "https://uat.esewa.com.np/epay/main";

      // var totalAmount =
      //   (this.getPromoDiscountTotal === 0
      //     ? this.cartTotal
      //     : this.getPromoDiscountTotal) +
      //   CartData.getDeliveryCharge() +
      //   this.getVAT +
      //   this.getIntlTransferCharge;

      // var totalAmount = CartData.getCartAmount();

      var params = {
        amt: this.totalAmount,
        psc: 0,
        pdc: 0,
        txAmt: 0,
        tAmt: this.totalAmount,
        pid: CartData.getOrderId(),
        // scd: "EPAYTEST",
        scd: "NP-ES-KHAANPIN",
        // su: "https://khaanpin.com.np/esewa/success.php",
        // su: "https://manager.khaanpin.com/apiv2/esewasu/",
        su: "https://deus.khaanpin.com/appapi/esewasu/",

        // fu: "https://khaanpin.com.np/esewafailed.php",
        // fu: "https://manager.khaanpin.com/apiv2/esewafu/",
        fu: "https://deus.khaanpin.com/appapi/esewafu/",

      };

      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", path);

      for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);
      form.submit();

      this.clearCart();
      this.updateStep(0);
    },

    // NICA Payment Methods
    handleNICASignature() {
      let totalA =
        (this.getPromoDiscountTotal === 0
          ? this.cartTotal
          : this.getPromoDiscountTotal) +
        CartData.getDeliveryCharge() +
        this.getVAT +
        this.getIntlTransferCharge;

      // let totalAmount = JSON.stringify(totalA);

      // let totalAmount = CartData.getCartAmount();

      let refNo = JSON.stringify(CartData.getOrderId());

      let transRefNo = this.generateRandom(20);

      let uu_id = this.generateUUID();

      let signedFieldNames =
        "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,payment_method,bill_to_forename,bill_to_surname,bill_to_email,bill_to_phone,bill_to_address_line1,bill_to_address_city,bill_to_address_state,bill_to_address_country,bill_to_address_postal_code,auth_trans_ref_no";

      let signature = {
        // access_key: "615ba3b427fe3de4822da91dff75431d", //Khaanpin test
        // access_key: "e8663c52c3ee327a8192611c3f7d7851", //Khaanpin live
        access_key: "d45aa73e04603c2bb6510e1115190720", //Khaanpin live


        profile_id: "29A0A19A-5AD4-4C1A-AC65-EB90AB3E3079", // Khaanpin test
        // profile_id: "43AEFE03-BDAD-4F08-92ED-7DD776C6DA10", // Khaanpin live

        transaction_uuid: uu_id,
        signed_field_names: signedFieldNames,
        unsigned_field_names: "card_type,card_number,card_expiry_date",

        signed_date_time: this.getDate(),
        // signed_date_time: "2020-12-27T09:33:49Z",

        locale: "en",
        transaction_type: "sale",

        // reference_number: Math.floor(Math.random() * 10000 + 1).toString(),
        reference_number: refNo,

        amount: JSON.stringify(this.totalAmount),
        currency: "NPR",
        payment_method: "card",

        //customers details
        bill_to_forename: "N/A",
        bill_to_surname: "N/A",
        bill_to_email: this.email,
        bill_to_phone: this.number,

        bill_to_address_line1: "N/A",
        bill_to_address_city: "N/A",
        bill_to_address_state: "N/A",
        bill_to_address_country: "NP",
        bill_to_address_postal_code: "N/A",

        card_type: "001",
        card_number: "",
        card_expiry_date: "",

        auth_trans_ref_no: transRefNo,
      };

      // let signedFields = signature.signed_field_names.split(",");

      // let fieldValues = [];

      // signedFields.forEach((item) => {
      //   fieldValues.push(item + "=" + signature[item]);
      // });

      // const crypto = require("crypto");

      // const hash = crypto
      //   .createHmac(
      //     "sha256",
      //     "9341fde2901c45df897cab43f7b64d58c5801e60a02849138bcbe22defbc0b6d16d31fd880944fd189739ab54182713e46fed24dd0c044ac9e897022830b27728729c04cb8264d48969f67f8f72909bcee9739179aa64df7a2850932f1e6c63d8061a3d0456f4a9f897c66ffb4517c6e4d7f1afd6ee54236a975d93dc29fc8b3"
      //   )
      //   .update(fieldValues.join(","))
      //   .digest("base64");

      axios
        .post(
          "https://manager.khaanpin.com/apiv2/getcybersignature/",
          signature
        )
        .then((response) => {
          if (response.data.error === true) {
            console.log("Process Failed", response.data);
          } else {
            this.handleNICAPayment(response.data.data);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    handleNICAPayment(response) {
      let totalA =
        (this.getPromoDiscountTotal === 0
          ? this.cartTotal
          : this.getPromoDiscountTotal) +
        CartData.getDeliveryCharge() +
        this.getVAT +
        this.getIntlTransferCharge;

      // let totalAmount = JSON.stringify(totalA);

      let refNumber = JSON.stringify(CartData.getOrderId());

      const headers = {
        "Content-Type": "application/json",
      };

      let signedFieldNames =
        "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,payment_method,bill_to_forename,bill_to_surname,bill_to_email,bill_to_phone,bill_to_address_line1,bill_to_address_city,bill_to_address_state,bill_to_address_country,bill_to_address_postal_code,auth_trans_ref_no";

      let payment = {
        // access_key: "615ba3b427fe3de4822da91dff75431d", //Khaanpin test
        // access_key: "e8663c52c3ee327a8192611c3f7d7851", //Khaanpin live
        access_key: "d45aa73e04603c2bb6510e1115190720", //Khaanpin live


        profile_id: "29A0A19A-5AD4-4C1A-AC65-EB90AB3E3079", // Khaanpin test
        // profile_id: "43AEFE03-BDAD-4F08-92ED-7DD776C6DA10", // Khaanpin live

        // transaction_uuid: "edf22984-5f1e-4f35-b793-c8a6b0ac36f0",
        transaction_uuid: response.transaction_uuid,

        signed_field_names: signedFieldNames,
        unsigned_field_names: "card_type,card_number,card_expiry_date",

        // signed_date_time: this.getDate(), //"2017-02-28T14:38:33Z",
        signed_date_time: response.datetime,
        locale: "en",
        transaction_type: "sale",

        // reference_number: Math.floor(Math.random() * 10000 + 1).toString(),
        reference_number: refNumber,
        amount: JSON.stringify(this.totalAmount),
        currency: "NPR",
        payment_method: "card",

        //customers details
        bill_to_forename: "N/A",
        bill_to_surname: "N/A",
        bill_to_email: this.email,
        bill_to_phone: this.number,

        bill_to_address_line1: "N/A",
        bill_to_address_city: "N/A",
        bill_to_address_state: "N/A",
        bill_to_address_country: "NP",
        bill_to_address_postal_code: "N/A",

        auth_trans_ref_no: response.auth_trans_ref_no,
        signature: response.hmac,

        card_type: "001",
        card_number: "",
        card_expiry_date: "",
      };

      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute(
        "action",
        "https://secureacceptance.cybersource.com/pay"
      );
      form.setAttribute("headers", headers);

      for (var key in payment) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", payment[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);
      form.submit();

      this.updateStep(0);
      this.clearCart();
    },

    generateRandom(length) {
      let orderID = JSON.stringify(CartData.getOrderId());
      let result = "";
      let characters = "0123456789";
      let charactersLength = characters.length;
      let idLength = length - orderID.length;
      for (var i = 0; i < idLength; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      let concatStr = orderID.concat(result);
      return concatStr;
    },

    generateUUID() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-bxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },

    getDate() {
      var date = new Date();
      var current_time =
        date.getUTCFullYear() +
        "-" +
        this.appendZero(date.getUTCMonth() + 1) +
        "-" +
        this.appendZero(date.getUTCDate()) +
        "T" +
        this.appendZero(date.getUTCHours()) +
        ":" +
        this.appendZero(date.getUTCMinutes()) +
        ":" +
        this.appendZero(date.getUTCSeconds()) +
        "Z";
      return current_time;
    },

    appendZero(digit) {
      if (digit < 10) {
        return "0" + digit;
      } else {
        return digit;
      }
    },

    // Fonepay Payment Methods
    getFonepayDate() {
      const date = format(new Date(), "MM/dd/yyyy");
      return date;
    },

    generateNewOrderID() {
      const orderID = JSON.stringify(CartData.getOrderId());
      const randomNo = Math.floor(Math.random() * 9000) + 1000;
      const newOrderID = orderID + "-" + randomNo;
      return newOrderID;
    },

    createFonePaySignature() {
      let totalA =
        (this.getPromoDiscountTotal === 0
          ? this.cartTotal
          : this.getPromoDiscountTotal) +
        CartData.getDeliveryCharge() +
        this.getVAT +
        this.getIntlTransferCharge;

      // let totalAmount = JSON.stringify(totalA);
      let refNo = this.generateNewOrderID();

      let signature = {
        PID: "PEKV", // merchant code
        MD: "P", // transaction mode (maybe)
        PRN: refNo, // product reference number
        AMT: this.totalAmount, // bill amount
        CRN: "NPR", // nepalese rupees
        DT: this.getFonepayDate(), // date
        R1: refNo, // remarks 1
        R2: "N/A", //remarks 2
        // RU: "https://manager.khaanpin.com/apiv2/fonepayru", // return url
        RU: "https://deus.khaanpin.com/appapi/fonepayru", // return url

      };

      // let signatureLocal = [
      //   {
      //     PID: "PEKV", // merchant code
      //     MD: "P", // transaction mode (maybe)
      //     PRN: refNo, // product reference number
      //     AMT: totalAmount, // bill amount
      //     CRN: "NPR", // nepalese rupees
      //     DT: this.getFonepayDate(), // date
      //     R1: refNo, // remarks 1
      //     R2: "N/A", //remarks 2
      //     RU: "https://manager.khaanpin.com/apiv2/fonepayru", // return url
      //   },
      // ];

      // const conStr = signatureLocal.reduce(
      //   (str, v, i) => str + `${i ? "," : ""}${Object.values(v)}`,
      //   ""
      // );

      // const crypto = require("crypto");

      // const hash = crypto
      //   .createHmac("sha512", "a7e3512f5032480a83137793cb2021dc")
      //   .update(conStr)
      //   .digest("hex");

      // console.log("HASH", hash);

      // const headers = {
      //   "Api-Key": "GfzglFRA.gSxaMxVDvwixVLDeiGcssYrLA2qISoSN",
      // };

      axios
        .post(
          "https://deus.khaanpin.com/appapi/getfonepaysignature/",
          signature
          // {
          //   headers: headers,
          // }
        )
        .then((response) => {
          if (response.data.error === true) {
            console.log("Process Failed", response.data);
          } else {
            this.handleFonepayPayment(response.data.data);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    handleFonepayPayment(data) {
      let totalA =
        (this.getPromoDiscountTotal === 0
          ? this.cartTotal
          : this.getPromoDiscountTotal) +
        CartData.getDeliveryCharge() +
        this.getVAT +
        this.getIntlTransferCharge;

      // let totalAmount = JSON.stringify(totalA);

      // const path = "https://dev-clientapi.fonepay.com/api/merchantRequest";
      const path = "https://clientapi.fonepay.com/api/merchantRequest";

      const params = {
        PID: "PEKV", // merchant code
        MD: "P", // transaction mode (maybe)
        PRN: data.prn, // product reference number
        AMT: this.totalAmount, // bill amount
        CRN: "NPR", // nepalese rupees
        DT: data.dt, // date
        R1: data.prn, // remarks 1
        R2: "N/A", //remarks 2
        RU: "https://deus.khaanpin.com/appapi/fonepayru", // return url
        DV: data.hmac,
      };

      const form = document.createElement("form");

      form.setAttribute("method", "GET");
      form.setAttribute("action", path);

      for (let key in params) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);
      form.submit();

      this.updateStep(0);
      this.clearCart();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

// new css
// variables
$theme-color: #ed3c3b;
$font-color: #706b6b;
$detail-color: #333;
$success-color: #60b246;
$info-color: #2e89d3;

$button-size: 16px;
$text-size: 16px;
$icon-size: 20px;
$heading-size: 24px;
$display-size: 36px;

$border: 1px solid rgba(3, 3, 3, 0.3);
$border-radius: 10px;

.menu {
  margin-bottom: 6%;
}

.order-placed {
  border: $border;
  border-radius: $border-radius;
  width: 50%;
  margin: 100px auto 0;
  padding: 30px;
  text-align: center;
  .heading {
    font-size: $heading-size;
    font-weight: bolder;
    color: $success-color;
  }
  p {
    font-size: $text-size;
    &:nth-child(2) {
      margin: 30px 0;
    }

    span {
      font-size: 14px;
    }
    .id {
      font-weight: bold;
      color: $theme-color;
      font-size: $heading-size;
    }
    .number {
      color: $theme-color;
    }
  }
}

.custom-button-wrap {
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  align-items: center;
  margin: 5px;
  height: auto;

  .custom-button {
    height: 50px;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 5px;

    &.green {
      background: #60b246;
      border-color: #60b246;
      &:hover {
        color: white;
      }
    }
    &.black {
      background: white;
      color: black;
      border-color: #60b246;
    }
    &.hide {
      display: none;
    }
  }
}

.loading {
  font-size: 18px;
  text-align: center;
  color: red;
  font-family: $main-font;
  margin-top: 30px;
}
</style>
